import React from 'react';
import { Tabs, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import TaskBoard from './TaskBoard';
import { PageHeaderLayout, PageContentLayout } from '../../../shared/layout';
import { withRouter, useLocation, useHistory, Switch, Route } from 'react-router-dom';
import UnassignedTasksView from './UnassignedTasksView';
import { HasAccess } from '@permify/react-role';
import { useTaskExport } from '../hooks/useTaskExport';
import '../styles/BoardTabs.css';
import TaskOverdueChart from './TaskOverdueChart';

const { TabPane } = Tabs;

const Task = () => {
  const location = useLocation();
  const history = useHistory();
  const { exportTasks, isExporting } = useTaskExport();

  const getActiveKey = () => {
    if (location.pathname.includes('/tasks/unassigned')) return '2';
    if (location.pathname.includes('/tasks/overdue')) return '3';

    return '1';
  };

  const handleTabChange = (key) => {
    switch (key) {
      case '1':
        history.push('/tasks/main/1');
        break;
      case '2':
        history.push('/tasks/unassigned/1');
        break;
      case '3':
        history.push('/tasks/overdue/');
        break;
      default:
        history.push('/tasks/main/1'); // Default to Task Board
        break;
    }
  };

  return (
    <>
      <PageHeaderLayout
        title="TASKS"
        style={{
          fontSize: '25px',
          border: 'none',
          paddingTop: '2vh',
        }}
      />
      <PageContentLayout style={{ backgroundColor: 'white', paddingInline: '2%' }}>
        <HasAccess roles={['PLATFORM']}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
            }}
          >
            <Tabs
              className="custom-tabs-tasks"
              activeKey={getActiveKey()}
              onChange={handleTabChange}
              type="card"
              tabBarStyle={{
                border: '4px solid #f1f5f9',
                borderRadius: '8px',
                width: 'fit-content',
                display: 'inline-flex',
              }}
            >
              <TabPane tab="Task Board" key="1" />
              <TabPane tab="Unassigned Tasks" key="2" />
              <TabPane tab="Overdue Tasks" key="3" />
            </Tabs>
            {getActiveKey() === '1' && (
              <Button
                onClick={exportTasks}
                style={{
                  fontSize: '15px',
                  height: '41px',
                  borderRadius: '5px',
                  backgroundColor: '#10b981',
                  color: 'white',
                }}
                icon={<DownloadOutlined />}
                disabled={isExporting}
                loading={isExporting}
              >
                Export Tasks
              </Button>
            )}
          </div>
          <Switch>
            <Route path="/tasks/unassigned/:pageNumber?" exact component={UnassignedTasksView} />
          </Switch>
          <Switch>
            <Route path="/tasks/overdue/" exact component={TaskOverdueChart} />
          </Switch>
        </HasAccess>
        <Switch>
          <Route path="/tasks/main/:pageNumber?" exact component={TaskBoard} />
        </Switch>
      </PageContentLayout>
    </>
  );
};

export default withRouter(Task);
